import { render, staticRenderFns } from "./PodChangeHistory.vue?vue&type=template&id=2a060ccc&"
import script from "./PodChangeHistory.vue?vue&type=script&lang=js&"
export * from "./PodChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports